module.exports = __webpack_public_path__ + "img/ring_g_o_1_1@2x.2904e494.png";